import React, {type JSX} from 'react';
import {Box, Link, Paper, Typography} from '@mui/material';
import {BlockHeader} from './shared';

function InfoBlock(): JSX.Element {
  return (
    <Paper
      elevation={0}
      data-testid="info-block"
      sx={theme => ({
        backgroundColor: theme.palette.grey[100],
        padding: theme.spacing(2, 3),
        '&.MuiPaper-root': {
          borderRadius: theme.spacing(1),
        },
      })}
    >
      <BlockHeader title="Need Help?" />
      <Box marginTop={2}>
        <Typography>
          If you have questions or need help please&nbsp;
          <Link href="mailto:support@healdbankone.com">contact support</Link>
        </Typography>
      </Box>
    </Paper>
  );
}

export default InfoBlock;
